/** CEE-1005 — keep in sync with organization-settings company-terminology.ts */

export const COMPANY_TERMINOLOGY_MAX_LENGTH = 25;

export const COMPANY_TERMINOLOGY_ALLOWED_RE = /^[a-zA-Z0-9 _-]*$/;

const COMPANY_TERMINOLOGY_CHAR_RE = /[a-zA-Z0-9 _-]/;

/** Strip disallowed characters and cap length while the user types. */
export function sanitizeCompanyTerminologyInput(raw: string): string {
  let out = '';
  for (const char of raw) {
    if (COMPANY_TERMINOLOGY_CHAR_RE.test(char)) {
      out += char;
      if (out.length >= COMPANY_TERMINOLOGY_MAX_LENGTH) {
        break;
      }
    }
  }
  return out;
}

export type CompanyTerminologyFieldError = 'max_length' | 'invalid_chars';

export type CompanyTerminologySubmitError = 'terminology_max_length' | 'invalid_chars';

/** Live feedback while typing or pasting — invalid chars first, then length over cap. */
export function getCompanyTerminologyInputFeedback(raw: string): CompanyTerminologyFieldError | undefined {
  if (raw.length === 0) {
    return undefined;
  }

  for (const char of raw) {
    if (!COMPANY_TERMINOLOGY_CHAR_RE.test(char)) {
      return 'invalid_chars';
    }
  }

  if (raw.length > COMPANY_TERMINOLOGY_MAX_LENGTH) {
    return 'max_length';
  }

  return undefined;
}

export function validateOptionalCompanyTerminology(
  value: string,
): CompanyTerminologySubmitError | undefined {
  const trimmed = value.trim();
  if (trimmed.length === 0) return undefined;

  if (trimmed.length > COMPANY_TERMINOLOGY_MAX_LENGTH) {
    return 'terminology_max_length';
  }

  if (!COMPANY_TERMINOLOGY_ALLOWED_RE.test(trimmed)) {
    return 'invalid_chars';
  }

  return undefined;
}
